import HeroPreview from './HeroPreview';
import HeroPreviewContainer from './HeroPreview.container';

export default HeroPreviewContainer(HeroPreview);
